import { render, staticRenderFns } from "./StockMovementStatusBadge.vue?vue&type=template&id=6394a005&"
import script from "./StockMovementStatusBadge.vue?vue&type=script&lang=js&"
export * from "./StockMovementStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports